<template>
  <div id="Dashboard" class="min-h-screen bg-bg">
    <div v-if="hydrated" class="mx-auto max-w-screen-xl px-4 py-8">
      <div class="grid grid-cols-1 gap-8 md:grid-cols-[272px_1fr] md:items-start">
        <aside class="order-2 md:order-1">
          <dashboard-sidebar />
        </aside>

        <div class="order-1 md:order-2">
          <div class="flex items-center justify-between gap-4">
            <dashboard-navigation />
            <button
              type="button"
              class="flex h-9 w-9 shrink-0 cursor-pointer items-center justify-center rounded-full border border-solid border-outline bg-white text-muted transition-colors hover:border-ink hover:text-ink"
              :title="$t('components.dashboard_sidebar.settings')"
              :aria-label="$t('components.dashboard_sidebar.settings')"
              data-testid="EditProfileButton"
              @click="toggleSettingsModal(true)"
            >
              <svg
                width="17"
                height="17"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M12 20h9" />
                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
              </svg>
            </button>
          </div>
          <div class="h-px bg-line" />

          <transition name="fade" mode="out-in">
            <router-view class="mt-6" />
          </transition>
        </div>
      </div>
    </div>

    <DashboardSettingsModal v-if="dashboardSettingsModalVisible" />
    <DashboardInterestsModal v-if="dashboardInterestsModalVisible" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import DashboardNavigation from '@/components/dashboard/DashboardNavigation'
import DashboardSidebar from '@/components/dashboard/DashboardSidebar'

const DashboardInterestsModal = () => import(/* webpackChunkName: "DashboardInterestsModal" */ '@/components/dashboard/DashboardInterestsModal.vue')
const DashboardSettingsModal = () => import(/* webpackChunkName: "DashboardSettingsModal" */ '@/components/dashboard/DashboardSettingsModal.vue')

export default {
  components: {
    DashboardNavigation,
    DashboardSidebar,
    DashboardSettingsModal,
    DashboardInterestsModal
  },
  data () {
    return {
      hydrated: false,
      isLoading: false
    }
  },
  computed: {
    ...mapGetters([
      'dashboardInterestsModalVisible',
      'dashboardSettingsModalVisible',
      'dashboardUserHasInterests'
    ])
  },
  mounted () {
    this.appLoading(true)
    this.fetchUser()
      .then(() => {
        this.appLoading(false)
        this.openInterestsModalIfNoInterests()
      })
  },
  methods: {
    ...mapActions(['toggleDashboardInterestsModal', 'toggleDashboardSettingsModal', 'fetchDashboardUser']),
    toggleSettingsModal (value) {
      this.toggleDashboardSettingsModal(value)
    },
    fetchUser () {
      this.isLoading = true
      return this.fetchDashboardUser()
        .then(response => {
          this.hydrated = true
        })
        .catch(error => {
          this.isLoading = false
          this.$displayRequestError(error, this.$t('errors.user_data_could_not_be_fetched'))
        })
    },
    openInterestsModalIfNoInterests () {
      if (!this.dashboardUserHasInterests) {
        this.toggleDashboardInterestsModal()
      }
    }
  }
}
</script>
